import React from 'react'
import axios from '~/data/http/axios'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import Hint from '~/Common-Objects/UI/Hint/Hint'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Row from '~/Common-Objects/Grids/Row/Row'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import i18n from '~/i18n'

export default class IncGoCopySubs extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            copyGroupID: 0,
            errorHolder: null,
            otherGroupData: {},
            pageLoaded: false
        }

        this.goCopySubs = this.goCopySubs.bind(this)
        this.goClickGroup = this.goClickGroup.bind(this)
        this.goGetGroups = this.goGetGroups.bind(this)
        this.upodateFilter = this.upodateFilter.bind(this)
        this.timer
    }

    componentDidMount() {
        this.goGetGroups()
    }

    goGetGroups() {
        var self = this

        axios.get('/group/simple?sortColumn=groupName').then((groups) => {
            var groupData = groups.data.Groups.filter((theGroup) => {
                return theGroup.id != self.props.groupId
            })
            if (groupData.length > 0) {
                var groupID = groupData[0].id
                self.setState({ otherGroupData: groupData, copyGroupID: groupID, pageLoaded: true })
            } else {
                self.setState({ otherGroupData: groupData, pageLoaded: true })
            }
        })
    }

    goCopySubs() {
        var self = this
        var theSubs = this.props.subscribers.filter((sub) => sub.checkBox.isChecked == true)
        var idsToCopy = theSubs.map((element, index) => {
            return element.subscriberData.id
        })
        this.setState({ pageLoaded: false })
        axios
            .post('/group/' + self.props.groupId + '/subscriber/copy', {
                subscriberIds: idsToCopy,
                destination: self.state.copyGroupID
            })
            .then((res) => {
                self.props.reloadAfterTickedAndChanged()
            })
            .catch((err) => {
                self.setState({ errorHolder: err.data.error.message })
            })
    }

    goClickGroup(e) {
        this.setState({ copyGroupID: e.currentTarget.value })
    }

    upodateFilter(val) {
        this.setState({ searchText: val }, () => {
            if (this.timer) clearTimeout(this.timer)
            this.timer = setTimeout(() => {
                this.goGetGroups()
            }, 350)
        })
    }

    render() {
        if (!this.state.pageLoaded) return <LoadingIcons iconType='2' />
        if (this.state.pageLoaded === true) {
            if (this.state.otherGroupData.length > 0) {
                return (
                    <div>
                        <div className='quickFlex mar-b25'>
                            <Hint
                                className='mar-0'
                                iconLeft={<Icons icon='arrowLeft' />}
                                onClick={this.props.goBack}
                            >
                                {i18n.t('goBack')}
                            </Hint>
                        </div>

                        <h4 className='mar-b25'>{i18n.t('subscribers:overview.copyHeader')}</h4>
                        <div className='mar-b25'>{i18n.t('subscribers:overview.copySubHeader')}</div>

                        <Select
                            filter={true}
                            outerClassName='mar-b25'
                            onChange={this.goClickGroup}
                            data={this.state.otherGroupData.map((group) => {
                                return { value: group.id, label: group.groupName }
                            })}
                            value={this.state.copyGroupID}
                            error={this.state.errorHolder}
                        />

                        <Button
                            text={i18n.t('subscribers:overview.copyButton')}
                            className='button-primary'
                            onClick={this.goCopySubs}
                        />
                    </div>
                )
            } else {
                return (
                    <Row>
                        <Column xs={12} sm={12} md={12}>
                            <div>
                                <div className='back middle-md' onClick={this.props.goBack}>
                                    <span className='icon-arrow-left'></span>
                                    <p className='no-marg'>{i18n.t('goBack')}</p>
                                </div>
                            </div>
                        </Column>

                        <Column xs={12} sm={12} md={12}>
                            <div>
                                <h4 className='no-marg'>{i18n.t('subscribers:overview.copyNoGroups')}</h4>
                            </div>
                        </Column>
                    </Row>
                )
            }
        } else {
            return <div></div>
        }
    }
}
